/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderLimitDto } from './OrderLimitDto';
import {
    OrderLimitDtoFromJSON,
    OrderLimitDtoFromJSONTyped,
    OrderLimitDtoToJSON,
} from './OrderLimitDto';
import type { ProductResponseDto } from './ProductResponseDto';
import {
    ProductResponseDtoFromJSON,
    ProductResponseDtoFromJSONTyped,
    ProductResponseDtoToJSON,
} from './ProductResponseDto';

/**
 * 
 * @export
 * @interface CatalogItemResponseDto
 */
export interface CatalogItemResponseDto {
    /**
     * Catalog item ID
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    id: number;
    /**
     * Product catalog ID
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    productCatalogId: number;
    /**
     * Product ID
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    productId: number;
    /**
     * Price for this product in the catalog
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    price: number;
    /**
     * Currency for the price
     * @type {string}
     * @memberof CatalogItemResponseDto
     */
    currency: CatalogItemResponseDtoCurrencyEnum;
    /**
     * Minimum order quantity
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    minimumOrderQty: number;
    /**
     * Maximum order quantity
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    maximumOrderQty: number | null;
    /**
     * Whether the product is in stock
     * @type {boolean}
     * @memberof CatalogItemResponseDto
     */
    inStock: boolean;
    /**
     * Stock quantity available (null = unlimited, 0 = out of stock)
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    stockQuantity: number | null;
    /**
     * Product details
     * @type {ProductResponseDto}
     * @memberof CatalogItemResponseDto
     */
    product: ProductResponseDto;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof CatalogItemResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof CatalogItemResponseDto
     */
    updatedAt: Date;
    /**
     * Description of the catalog item
     * @type {string}
     * @memberof CatalogItemResponseDto
     */
    description?: string;
    /**
     * Lead time for the product in days
     * @type {number}
     * @memberof CatalogItemResponseDto
     */
    leadTime?: number;
    /**
     * Order limit for this catalog item
     * @type {OrderLimitDto}
     * @memberof CatalogItemResponseDto
     */
    orderLimit?: OrderLimitDto;
}


/**
 * @export
 */
export const CatalogItemResponseDtoCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type CatalogItemResponseDtoCurrencyEnum = typeof CatalogItemResponseDtoCurrencyEnum[keyof typeof CatalogItemResponseDtoCurrencyEnum];


/**
 * Check if a given object implements the CatalogItemResponseDto interface.
 */
export function instanceOfCatalogItemResponseDto(value: object): value is CatalogItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('productCatalogId' in value) || value['productCatalogId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('minimumOrderQty' in value) || value['minimumOrderQty'] === undefined) return false;
    if (!('maximumOrderQty' in value) || value['maximumOrderQty'] === undefined) return false;
    if (!('inStock' in value) || value['inStock'] === undefined) return false;
    if (!('stockQuantity' in value) || value['stockQuantity'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CatalogItemResponseDtoFromJSON(json: any): CatalogItemResponseDto {
    return CatalogItemResponseDtoFromJSONTyped(json, false);
}

export function CatalogItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'productCatalogId': json['productCatalogId'],
        'productId': json['productId'],
        'price': json['price'],
        'currency': json['currency'],
        'minimumOrderQty': json['minimumOrderQty'],
        'maximumOrderQty': json['maximumOrderQty'],
        'inStock': json['inStock'],
        'stockQuantity': json['stockQuantity'],
        'product': ProductResponseDtoFromJSON(json['product']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['leadTime'] == null ? undefined : json['leadTime'],
        'orderLimit': json['orderLimit'] == null ? undefined : OrderLimitDtoFromJSON(json['orderLimit']),
    };
}

export function CatalogItemResponseDtoToJSON(value?: CatalogItemResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'productCatalogId': value['productCatalogId'],
        'productId': value['productId'],
        'price': value['price'],
        'currency': value['currency'],
        'minimumOrderQty': value['minimumOrderQty'],
        'maximumOrderQty': value['maximumOrderQty'],
        'inStock': value['inStock'],
        'stockQuantity': value['stockQuantity'],
        'product': ProductResponseDtoToJSON(value['product']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'description': value['description'],
        'leadTime': value['leadTime'],
        'orderLimit': OrderLimitDtoToJSON(value['orderLimit']),
    };
}

